import { useId, useState } from "react";
import TrainingMedia from "./TrainingMedia";

const availableVideo = media => typeof media?.id === "string"
  && /^[a-zA-Z0-9_-]{1,128}$/.test(media.id) && media.status === "ready";

export function AdminTrainingLibraryVideo({ media, lang, onStatusChange }) {
  if (!availableVideo(media)) return null;
  return <TrainingMedia mediaId={media.id} adminPreview lang={lang} onStatusChange={onStatusChange} />;
}

export default function AdminTrainingLibraryMedia({ value, onChange, media = [], uploadAvailable, copy, lang }) {
  const uploadHintId = useId();
  const [preview, setPreview] = useState(null);
  const selected = media.find((item) => item.id === value);
  const previewUnavailable = preview?.mediaId === value && preview?.status === "unavailable";
  return <section className="atl-stack" aria-label={copy.video}>
    <label className="atl-field"><span>{copy.selectVideo}</span><select className="pc-input" data-testid="library-video-select" value={value || ""} onChange={(event) => onChange(event.target.value || null)}>
      <option value="">{copy.noVideo}</option>
      {value && !selected && <option value={value} disabled>{`${copy.missing} · ${value}`}</option>}
      {media.map((item) => <option key={item.id} value={item.id} disabled={!availableVideo(item)}>{`${item.title || item.id} · ${item.id === value && previewUnavailable ? copy.missing : copy[item.status] || item.status || copy.missing}`}</option>)}
    </select></label>
    {value && <><p className="atl-muted" role="status">{copy.mediaStatus}: {previewUnavailable ? copy.missing : copy[selected?.status] || selected?.status || copy.missing}</p>
      <AdminTrainingLibraryVideo key={value} media={selected} lang={lang} onStatusChange={setPreview} />
      {(!availableVideo(selected) || previewUnavailable) && <p className="atl-muted">{copy.videoUnavailable}</p>}
      <button type="button" className="pc-btn pc-btn-ghost" onClick={() => onChange(null)}>{copy.removeVideo}</button></>}
    <div className="atl-notice"><button type="button" className="pc-btn pc-btn-ghost" disabled aria-describedby={uploadHintId}>{copy.upload}</button>
      <p id={uploadHintId} className="atl-muted">{uploadAvailable ? copy.uploadPending : copy.uploadUnavailable}</p></div>
  </section>;
}
